import React, { FC } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { Text } from '@shared/ui/atoms';
import { breadcrumbsSizes, breadcrumbsTextSizes } from '@shared/config/components/breadcrumbs';
import { baseColors, useTheme, withTheme } from '@shared/lib/theme';
type SizeValue = keyof typeof breadcrumbsSizes;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
export interface BreadcrumbItemType {
  label: string;
  href?: string;
}
interface BreadcrumbItemProps {
  size: ResponsiveSize;
  item: BreadcrumbItemType;
}
const BreadcrumbItem: FC<BreadcrumbItemProps> = ({
  size = 's',
  item
}) => {
  const {
    theme
  } = useTheme();
  const desktopSize = typeof size === 'object' ? size.desktop || 's' : size || 's';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 's';
  return <BreadcrumbItemWrapper>
      {!item.href ?
    // Текущая страница (не кликабельна)
    <Text family="MTSCompact" size={{
      desktop: breadcrumbsTextSizes[desktopSize],
      mobile: breadcrumbsTextSizes[mobileSize]
    }} weight="medium" color={theme.colors.constant.white}>
          {item.label}
        </Text> :
    // Ссылка на предыдущие страницы
    <Link passHref href={item.href}>
          <Text family="MTSCompact" size={{
        desktop: breadcrumbsTextSizes[desktopSize],
        mobile: breadcrumbsTextSizes[mobileSize]
      }} weight="medium" color={theme.colors.constant.white}>
            {item.label}
          </Text>
        </Link>}
    </BreadcrumbItemWrapper>;
};
export default BreadcrumbItem;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.constant.white;
const BreadcrumbItemWrapper = withTheme(/*#__PURE__*/styled('li')({
  name: "BreadcrumbItemWrapper",
  class: "b1b9kd4b",
  propsAsIs: false,
  vars: {
    "b1b9kd4b-0": [_exp()]
  }
}));

require("./BreadcrumbItem.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./BreadcrumbItem.tsx");